var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-whatsapp",
        title: "Add WhatsApp Content",
        "hide-footer": "",
        size: "lg",
        centered: "",
      },
      on: { hidden: _vm.resetForm },
    },
    [
      _c("validation-observer", {
        ref: "observer",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var handleSubmit = ref.handleSubmit
              var invalid = ref.invalid
              return [
                _c(
                  "b-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.validateAndSubmit)
                      },
                    },
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Post Name",
                                  "label-for": "campaign_name",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "campaign name",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              on: {
                                                blur: _vm.validateCampaignName,
                                              },
                                              model: {
                                                value: _vm.campaignName,
                                                callback: function ($$v) {
                                                  _vm.campaignName = $$v
                                                },
                                                expression: "campaignName",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Post Template",
                                  "label-for": "email_template",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "email template",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.emailtemplatelist,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              on: {
                                                change: _vm.onTemplateSelect,
                                              },
                                              model: {
                                                value: _vm.selectedTemplateId,
                                                callback: function ($$v) {
                                                  _vm.selectedTemplateId = $$v
                                                },
                                                expression:
                                                  "selectedTemplateId",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: { label: "Budget", "label-for": "cost" },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required|numeric|min_value:1",
                                    name: "cost",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                placeholder: "Enter Budget",
                                                type: "number",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              on: { blur: _vm.validateCost },
                                              model: {
                                                value: _vm.cost,
                                                callback: function ($$v) {
                                                  _vm.cost = $$v
                                                },
                                                expression: "cost",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Segment",
                                  "label-for": "segment",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "segment",
                                    vid: "Segment",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("v-select", {
                                              staticClass:
                                                "item-selector-title",
                                              attrs: {
                                                options: _vm.segmentOptions,
                                                label: "itemTitle",
                                                multiple: "",
                                                clearable: false,
                                                placeholder: "Select Item",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.selectedSegments,
                                                callback: function ($$v) {
                                                  _vm.selectedSegments = $$v
                                                },
                                                expression: "selectedSegments",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "WhatsApp Content",
                                  "label-for": "whatsapp_content",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "whatsapp content",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-textarea", {
                                              attrs: {
                                                id: "whatsapp_content",
                                                placeholder:
                                                  "WhatsApp content will be displayed here",
                                                readonly: "",
                                                rows: "7",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedTemplate.body,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedTemplate,
                                                    "body",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedTemplate.body",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.templateInputs[_vm.selectedTemplateId]
                          ? _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  { attrs: { label: "Fill Details" } },
                                  [
                                    _vm._l(
                                      _vm.templateInputs[
                                        _vm.selectedTemplateId
                                      ],
                                      function (placeholder, key) {
                                        return [
                                          _c("validation-provider", {
                                            key: key,
                                            attrs: {
                                              rules:
                                                _vm.getValidationRules(key),
                                              name: placeholder,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "div",
                                                        { staticClass: "mb-3" },
                                                        [
                                                          _vm.isNumericField(
                                                            key
                                                          )
                                                            ? _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    placeholder:
                                                                      placeholder,
                                                                    type: "number",
                                                                    min: "1",
                                                                    max: "100",
                                                                    state:
                                                                      errors.length >
                                                                      0
                                                                        ? false
                                                                        : null,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.updateTemplateBody,
                                                                    blur: function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.validateOfferField(
                                                                        key
                                                                      )
                                                                    },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .offerDetails[
                                                                        key
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.offerDetails,
                                                                          key,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "offerDetails[key]",
                                                                  },
                                                                }
                                                              )
                                                            : _vm.isDateField(
                                                                key
                                                              )
                                                            ? _c(
                                                                "b-form-datepicker",
                                                                {
                                                                  attrs: {
                                                                    placeholder:
                                                                      placeholder,
                                                                    state:
                                                                      errors.length >
                                                                      0
                                                                        ? false
                                                                        : null,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.updateTemplateBody,
                                                                    blur: function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.validateOfferField(
                                                                        key
                                                                      )
                                                                    },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .offerDetails[
                                                                        key
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.offerDetails,
                                                                          key,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "offerDetails[key]",
                                                                  },
                                                                }
                                                              )
                                                            : _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    placeholder:
                                                                      placeholder,
                                                                    state:
                                                                      errors.length >
                                                                      0
                                                                        ? false
                                                                        : null,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.updateTemplateBody,
                                                                    blur: function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.validateOfferField(
                                                                        key
                                                                      )
                                                                    },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .offerDetails[
                                                                        key
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.offerDetails,
                                                                          key,
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "offerDetails[key]",
                                                                  },
                                                                }
                                                              ),
                                                          errors.length
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "text-danger d-flex align-items-center",
                                                                },
                                                                [
                                                                  _c("b-icon", {
                                                                    attrs: {
                                                                      icon: "exclamation-triangle-fill",
                                                                    },
                                                                  }),
                                                                  _c("small", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-end",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          { attrs: { type: "submit", variant: "primary" } },
                          [_vm._v("Save as draft")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }